/**
 * 흐름 화살표 컴포넌트.
 * - VerticalArrow: 단일 카드 사이 세로 화살표
 * - BranchArrow: 1 → 3 분기 (P-1 → A·B·C)
 * - MergeArrow: 3 → 1 합류 (A·B·C → D)
 */

interface ArrowProps {
  dim?: boolean;
}

const arrowStyle = (dim: boolean) => ({
  opacity: dim ? 0.25 : 1,
  transition: 'opacity 300ms',
});

/** 단일 세로 화살표 */
export function VerticalArrow({ dim = false }: ArrowProps) {
  return (
    <div
      className="flex flex-col items-center py-1"
      style={arrowStyle(dim)}
      aria-hidden="true"
    >
      <div className="w-px h-6 bg-bdr-subtle" />
      <svg width="10" height="7" viewBox="0 0 10 7" className="text-fg-subtle">
        <path d="M5 7 L0 0 L10 0 Z" fill="currentColor" />
      </svg>
    </div>
  );
}

/**
 * 분기 화살표: 1줄기 → 3갈래.
 * 카드 3개가 grid-cols-3 에 있을 때 그 위에 배치.
 */
export function BranchArrow({ dim = false }: ArrowProps) {
  return (
    <div
      className="relative flex justify-center"
      style={{ height: 48, ...arrowStyle(dim) }}
      aria-hidden="true"
    >
      <svg width="100%" height="48" viewBox="0 0 300 48" preserveAspectRatio="none">
        {/* 세로 중심선 */}
        <line x1="150" y1="0" x2="150" y2="22" stroke="hsl(0 0% 86%)" strokeWidth="1" />
        {/* 가로 분기 바 */}
        <line x1="50" y1="22" x2="250" y2="22" stroke="hsl(0 0% 86%)" strokeWidth="1" />
        {/* 왼쪽 내림선 + 화살표 */}
        <line x1="50" y1="22" x2="50" y2="41" stroke="hsl(0 0% 86%)" strokeWidth="1" />
        <polygon points="50,48 45,40 55,40" fill="hsl(0 0% 86%)" />
        {/* 중간 내림선 + 화살표 */}
        <line x1="150" y1="22" x2="150" y2="41" stroke="hsl(0 0% 86%)" strokeWidth="1" />
        <polygon points="150,48 145,40 155,40" fill="hsl(0 0% 86%)" />
        {/* 오른쪽 내림선 + 화살표 */}
        <line x1="250" y1="22" x2="250" y2="41" stroke="hsl(0 0% 86%)" strokeWidth="1" />
        <polygon points="250,48 245,40 255,40" fill="hsl(0 0% 86%)" />
      </svg>
    </div>
  );
}

/**
 * 합류 화살표: 3갈래 → 1줄기.
 * 카드 3개 아래에 배치.
 */
export function MergeArrow({ dim = false }: ArrowProps) {
  return (
    <div
      className="relative flex justify-center"
      style={{ height: 48, ...arrowStyle(dim) }}
      aria-hidden="true"
    >
      <svg width="100%" height="48" viewBox="0 0 300 48" preserveAspectRatio="none">
        {/* 왼쪽 올라오는 선 */}
        <line x1="50" y1="0" x2="50" y2="26" stroke="hsl(0 0% 86%)" strokeWidth="1" />
        {/* 중간 올라오는 선 */}
        <line x1="150" y1="0" x2="150" y2="26" stroke="hsl(0 0% 86%)" strokeWidth="1" />
        {/* 오른쪽 올라오는 선 */}
        <line x1="250" y1="0" x2="250" y2="26" stroke="hsl(0 0% 86%)" strokeWidth="1" />
        {/* 가로 합류 바 */}
        <line x1="50" y1="26" x2="250" y2="26" stroke="hsl(0 0% 86%)" strokeWidth="1" />
        {/* 중심 내림선 + 화살표 */}
        <line x1="150" y1="26" x2="150" y2="41" stroke="hsl(0 0% 86%)" strokeWidth="1" />
        <polygon points="150,48 145,40 155,40" fill="hsl(0 0% 86%)" />
      </svg>
    </div>
  );
}
